<template>
  <v-form action="javascript:void(0);" method="post" ref="form" id="contact-form">
    <v-container class="pa-0">
      <v-layout row class="info-pill">
        <v-flex d-flex pr-1><v-icon>info</v-icon></v-flex>
        <v-flex d-flex>{{$tf('web support warning')}}</v-flex>
      </v-layout>
      <v-layout wrap>
          <v-flex xs12 sm6 md4>
            <v-text-field
                ref="firstname"
                name="firstname"
                :label="$tf('Firstname')"
                required
                v-model="fields.firstname.value"
                :rules="fields.firstname.rules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
                name="lastname"
                :label="$tf('Lastname')"
                required
                v-model="fields.lastname.value"
                :rules="fields.lastname.rules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
                name="email"
                label="Email"
                required
                v-model="fields.email.value"
                id="email"
                :rules="fields.email.rules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
                name="message"
                :label="$tf('Your message')"
                required
                v-model="fields.message.value"
                multi-line
                :rules="fields.message.rules"
              ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 class="version">
            <em><b>Version: </b><span>{{$version.version}} - {{$version.compilation}}</span></em>
          </v-flex> -->
        </v-layout>
    </v-container>
  </v-form>
</template>

<script>
  import useInPlaceValidation from '~/commons/validation'
  import { ref } from '@vue/composition-api'
  export default {
    name: 'contact-form',
    props: {
      submit: {
        type: Boolean,
        default: false
      },
      reset: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      account: {
        type: Object,
        default: () => ({})
      }
    },
    setup (props) {
      const { fields, setValidationCallback } = useInPlaceValidation({
        firstname: {
          name: 'Firstname',
          rules: ['required', 'maxLength:100'],
          value: ref(props.account.firstname)
        },
        lastname: {
          name: 'Lastname',
          rules: ['required', 'maxLength:100'],
          value: ref(props.account.lastname)
        },
        email: {
          name: 'Email',
          rules: ['required', 'email'],
          value: ref(props.account.email)
        },
        message: {
          name: 'Your message',
          rules: ['required'],
          value: ref('')
        }
      })
      return {
        fields,
        setValidationCallback
      }
    },
    mounted () {
      this.setValidationCallback(this.setValid)
    },
    methods: {
      setValid (valid) {
        this.$store.dispatch('dialog/setValid', valid)
      },
      cancel () {},
      accept () {
        if (!this.$refs.form.validate()) {
          this.$store.dispatch('dialog/setValid', false)
          throw new Error('Form is not valid')
        }
        this.$store.dispatch('dialog/setValid', true)
        return this.$http.post('https://us-central1-idonia-public.cloudfunctions.net/idonia-ui-troubleshoot-function-sendmail', {
          'name': this.fields.firstname.value + ' ' + this.fields.firstname.value,
          'email': this.fields.email.value,
          'message': this.fields.message.value,
          'version': this.$version.version + ' - ' + this.$version.compilation
        }
            ).then(() => {
              this.$store.dispatch('feedback/addSnack', {
                text: this.$tf(`Thank you, your message has been sent`),
                type: 'info',
                timeout: 2000
              })
            })
      }
    }
  }

</script>

<style>
  #contact-form .input-group--required label:after {
    padding-left: 5px;
    color: red;
  }
</style>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogContactForm.vue